import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import NewsList from "./components/NewsList";

export default function NewsPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <NewsList />
      <Footer />
    </div>
  );
}
